import React, { Component } from 'react';
import TopNav from './Comp/Shared/TopNav';
import Loader from './Comp/Shared/Loader';
import BackgroundEffects from './Comp/BackgroundEffects';
import Intro from './Comp/Intro';
import DescriptivePage from './Comp/DescriptivePage';
import EndOfSurvey from './Comp/EndOfSurvey';
import QuestionPage from './Comp/QuestionPage';
import OpenQuestionPage from './Comp/OpenQuestionPage';
import NumberQuestionPage from './Comp/NumberQuestionPage';
import ScaleQuestionPage from './Comp/ScaleQuestionPage';
import DropdownSelectionPage from './Comp/DropdownSelectionPage';
import MultipleChoicePage from './Comp/MultipleChoicePage';
import ImagePage from './Comp/ImagePage';
import VideoPage from './Comp/VideoPage';
import GiftEnd from './Comp/GiftEnd';
import AlternativEnd from './Comp/AlternativEnd';
import SubmitAPI from './SubmitAPI';
import BlocksToStepsParser from './Utils/BlocksToStepsParser';
import Cookies from 'universal-cookie';
import uuidv4 from 'uuid/v4';
import { random } from 'node-forge';
import NotFoundPage from './Comp/NotFoundPage';
import { handleSbs, listenForSbsEvents } from './SBSmanager';

import TagManager from 'react-gtm-module';
import { data } from 'jquery';

// Google Tag Manager:
const tagManagerArgs = {
	gtmId: 'GTM-NVS8R3F'
}

TagManager.initialize(tagManagerArgs)

const cookies = new Cookies();
const LS = {
	get: (key) => {
		var localStorageItem = null;
		try {
			localStorageItem = localStorage.getItem(key);
		} catch (e) { }
		if (localStorageItem !== null) {
			return localStorageItem
		}
		return cookies.get(key)
	},
	set: (key, value) => {
		try {
			localStorage.setItem(key, value);
		} catch (e) { }
		cookies.set(key, value, { path: '/' })
	}
}

// FIX for Internet explorer that dosen't have find in array
// https://github.com/appbaseio/reactivesearch/issues/578
if (!Array.prototype.find) {
	Object.defineProperty(Array.prototype, 'find', {
		value: function (predicate) {
			// 1. Let O be ? ToObject(this value).
			if (this == null) {
				throw new TypeError('"this" is null or not defined');
			}

			var o = Object(this);

			// 2. Let len be ? ToLength(? Get(O, "length")).
			var len = o.length >>> 0;

			// 3. If IsCallable(predicate) is false, throw a TypeError exception.
			if (typeof predicate !== 'function') {
				throw new TypeError('predicate must be a function');
			}

			// 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
			var thisArg = arguments[1];

			// 5. Let k be 0.
			var k = 0;

			// 6. Repeat, while k < len
			while (k < len) {
				// a. Let Pk be ! ToString(k).
				// b. Let kValue be ? Get(O, Pk).
				// c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
				// d. If testResult is true, return kValue.
				var kValue = o[k];
				if (predicate.call(thisArg, kValue, k, o)) {
					return kValue;
				}
				// e. Increase k by 1.
				k++;
			}

			// 7. Return undefined.
			return undefined;
		},
		configurable: true,
		writable: true
	});
}


const COMP_DICT = {
	Intro,
	DescriptivePage,
	EndOfSurvey,
	QuestionPage,
	OpenQuestionPage,
	MultipleChoicePage,
	NumberQuestionPage,
	ScaleQuestionPage,
	DropdownSelectionPage,
	ImagePage,
	VideoPage,
	AlternativEnd,
	GiftEnd,
}

class App extends Component {
	state = {
		winWidth: 360,
		winHeight: 640,
		isHorizontal: false,
		surveyNotFound: false,
		pos: 0,
		lastPos: -1,
		makeTransition: true,
		loaderCount: 0,
		steps: [],
		bgImgUrl: "",
		hideStepNumbers: false,
		hideSerialNumber: false,
		stepStartTimestamp: 0,
		allowNext: true,

		stepsCount: 0 // counting steps completed by the user. usefull for analytics.
	}

	getSurvey(props) {
		fetch(`${global.URL}/seker_data/${props.sekerKey}`).then(response => response.json()).then(j => {
			if (j.errCode === 'SEKER_NOT_FOUND') {

				this.setState({ surveyNotFound: true });
				console.error('survey not fount');

				return
			}
			j.Screen.forEach(scr => {
				if (scr.QuestionPage.answers) {
					// console.log(scr.QuestionPage.answers);
					// console.log(JSON.parse(scr.QuestionPage.answers));
					scr.QuestionPage.answers = JSON.parse(scr.QuestionPage.answers);
				}
				if (scr.MultipleChoicePage !== undefined && scr.MultipleChoicePage.answers) {
					scr.MultipleChoicePage.answers = JSON.parse(scr.MultipleChoicePage.answers);
				}
				if (scr.ScaleQuestionPage.items) {
					scr.ScaleQuestionPage.items = JSON.parse(scr.ScaleQuestionPage.items);
				}
				if (scr.DropdownSelectionPage.lists) {
					scr.DropdownSelectionPage.lists = JSON.parse(scr.DropdownSelectionPage.lists);
				}
				if (scr.ImagePage && scr.ImagePage.scaleItems) {
					scr.ImagePage.scaleItems = JSON.parse(scr.ImagePage.scaleItems);
				}
			});
			// console.log( JSON.stringify(j, null, 4) );
			this.sekerData = j
			this.createSurvey()
		}).catch(err => {
			console.log(err)
			setTimeout(() => {
				alert("Err_3.14 Server error")
			}, 50)
			window.onerror('ERROR 3.14' + JSON.stringify(err))
			//@TODO do somthing...
		})
	}

	getCacheData(props) {
		this.hzId = LS.get(`hzId`)
		if (!this.hzId) {
			this.hzId = uuidv4()
			LS.set(`hzId`, this.hzId)
		}

		if (global.isPreview || this.isNewUuid) {
			this.cachedData = {}
			return this.createSurvey()
		}
		console.log("getCacheData SN: " + this.seedNumber)
		fetch(`${global.CACHE_URL}/getUserAns/${props.sekerKey}/${this.userId}_${this.seedNumber}_${this.hzId}`).then(response => response.json()).then(j => {
			console.log(j)
			this.cachedData = j.redisRes || {}
			this.createSurvey()
		}).catch(() => {
			// ignore cache
			this.cachedData = {}
			this.createSurvey()
		})
	}
	setCacheAnswer(k, v) {
		this.hzId = LS.get(`hzId`)
		if (!this.hzId) {
			this.hzId = uuidv4()
			LS.set(`hzId`, this.hzId)
		}

		fetch(`${global.CACHE_URL}/setUserAns`, {
			method: 'POST',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				uid: `${this.userId}_${this.seedNumber}_${this.hzId}`,
				sekerKey: this.props.sekerKey,
				k, v
			})
		})
		if (this.userId && this.seedNumber && this.hzId) {
			global.rid = `${this.userId}_${this.seedNumber}_${this.hzId}`
		}
	}

	createSurvey() {
		console.log('[CRE_SRVY]')
		if (!this.sekerData || !this.cachedData) return
		if (!this.cachedData.seedNumber) {


			// create a seed number and set it as a answer
			global.setAnswer("seedNumber", this.seedNumber)
			this.cachedData.seedNumber = this.seedNumber
			global.setAnswer("_cacheKey", this.userId)
			global.setAnswer("start_filling_timestamp", Date.now())
		}

		let steps = this.sekerData.Screen;
		if (this.sekerData.version >= 1) {
			console.log("BlocksToStepsParser SN: " + this.cachedData.seedNumber)
			steps = BlocksToStepsParser(this.sekerData.Screen, this.sekerData.Blocks, this.sekerData.blocksOrder, Number(this.cachedData.seedNumber));
			// console.log(steps);
		}

		if (global.browser !== "ie") {
			global.SetColorTheme(this.sekerData.colorTheme);
		}
		global.ansData = this.cachedData
		this.setState({
			steps: steps,
			bgImgUrl: this.sekerData.image !== undefined ? this.sekerData.image.url : "",
			hideStepNumbers: this.sekerData.hideStepNumbers,
			hideSerialNumber: this.sekerData.hideSerialNumber
		}, _ => {
			if (global.isPreview) {
				this.previewNav()
			} else {
				if (this.cachedData.curScreen) {

					// Quick Fix
					if (this && this.props && this.props.sekerKey == 'YnetKayma') {
						console.log(this.cachedData)
						const sn = this.cachedData.seedNumber
						this.cachedData = { seedNumber: sn }
						return this.Nav(0)
					}
					if (this && this.props && this.props.sekerKey == 'digital-mobile') {
						console.log(this.cachedData)
						const sn = this.cachedData.seedNumber
						this.cachedData = { seedNumber: sn }
						return this.Nav(0)
					}
					if (this && this.props && this.props.sekerKey == 'Digital-desktop') {
						console.log(this.cachedData)
						const sn = this.cachedData.seedNumber
						this.cachedData = { seedNumber: sn }
						return this.Nav(0)
					}
					if (this && this.props && this.props.sekerKey == 'suppliers-survey') {
						console.log(this.cachedData)
						const sn = this.cachedData.seedNumber
						this.cachedData = { seedNumber: sn }
						return this.Nav(0)
					}
					// End Of Quick fix

					this.Nav(Number(this.cachedData.curScreen))

				} else {
					this.Nav(0)
				}
			}
		})


	}

	constructor(props) {
		super(props)
		global.isPreview = false;
		if (this.props.userId && this.props.userId.slice(0, 13) === 'sekerpreview=') {
			global.isPreview = true
		}


		//Called by screen components when users choose an answer:
		global.setAnswer = (q, ans, inx) => {
			global.ansData[q] = ans
			this.setCacheAnswer(q, ans)
			if (!isNaN(inx)) {
				const k = q + "_inx"
				global.ansData[k] = inx
				this.setCacheAnswer(k, inx)
			}
		}
		this.userId = props.userId || LS.get(`sKey_${props.sekerKey}`)
		console.log("CK = " + LS.get(`sKey_${props.sekerKey}`))
		if (!this.userId) {
			this.userId = uuidv4()
			this.isNewUuid = true
			console.log("SET CK:" + ` sKey_${props.sekerKey}` + ' = ' + this.userId)
			LS.set(`sKey_${props.sekerKey}`, this.userId, { path: '/' })
		}
		this.seedNumber = LS.get(`sKey_${props.sekerKey}_seedNumber`)
		if (!this.seedNumber) {
			this.seedNumber = Math.round(Math.random() * 1000000000000)
			LS.set(`sKey_${props.sekerKey}_seedNumber`, this.seedNumber)
		}
		this.getCacheData(props)
		this.getSurvey(props)

		//Called by screen components when users done interacticg with them:
		global.nextStage = (nextKey) => {

			// console.log( "nextKey: " + nextKey );
			let nextPos;

			this.setGoogleTagManagerDataLayer(false);

			//nextKey will hold the key of the following screen, 
			//according to the screen properties and the choosen answer (if followTo parameter is set to "by_ans")
			if (nextKey === "next_screen" || !nextKey) {
				nextPos = this.state.pos + 1;
			} else {
				//Get the following step by the key:
				for (let i = 0; i < this.state.steps.length; i++) {
					if (this.state.steps[i].qKey === nextKey) {
						nextPos = i;
					}
				}
			}

			if (nextPos === undefined) {
				console.log("[global.nextStage] error while looking for following screen");
				return;
			}

			const { injectedScript } = this.state.steps[nextPos]


			if (injectedScript) {
				// console.log( injectedScript );
				const newScript = document.createElement('script')
				newScript.text = injectedScript
				document.head.appendChild(newScript)
			}
			const nextStepType = this.state.steps[nextPos].type;


			//End the survey if the next screen is type of the following:
			if (nextStepType === "EndOfSurvey" || nextStepType === "AlternativEnd" || nextStepType === "GiftEnd") {
				//end of survey
				console.log("end of survey");
				console.log(`[+]\t SUMBIT RESULTS DUMMY...`);

				this.setGoogleTagManagerDataLayer(true);

				//Save the time it took the participant to fill the survey:
				global.endTimeStamp = Date.now();
				const fillingDuration = (global.endTimeStamp - global.startTimeStamp) / 1000; //duration in seconds
				global.ansData["filling_duration"] = fillingDuration;
				global.ansData["filling_date"] = Date(Date.now()).toString();
				global.ansData["filling_date_timestamp"] = Date.now();

				console.log("global._queryDict = " + JSON.stringify(global._queryDict))
				if (global._queryDict) {
					Object.keys(global._queryDict).forEach(key => {
						console.log("Setting url_param_" + key + " = " + global._queryDict[key])
						global.ansData["url_param_" + key] = global._queryDict[key];
					});
				}

				if (this.hzId) {
					global.ansData["_hzId"] = this.hzId;
				}

				global.setAnswer("_lastScreenKey", this.state.steps[nextPos].qKey)
				const uid = props.userId || 'NONE'
				//Submit results only if we're not in preview mode
				if (global.isPreview) {
					this.Nav(nextPos);
					console.log("preview answers: " + JSON.stringify(global.ansData, null, 2))
				} else {
					SubmitAPI.sendData(props.sekerKey, uid, done => {
						if (done) {
							this.Nav(nextPos);
						} else {
							alert("השרת לא זמין, אנא נסו שוב מאוחר יותר")
						}
					})
				}

			} else { //Proceed to the next screen:

				const step = this.state.steps[this.state.pos];
				const stepKey = step.qKey;

				//Save the time it took the participant to fill the last screen:
				const stepEndTimeStamp = Date.now();
				const stepDuration = (stepEndTimeStamp - this.state.stepStartTimestamp) / 1000;
				global.setAnswer(stepKey + "_duration", stepDuration);
				this.Nav(nextPos);

			}

		}

		//addLoader is called when we want to present a loading animation while waiting for something to happen (response from the server for example)
		global.addLoader = () => {
			this.setState({ loaderCount: this.state.loaderCount + 1 });
		}
		//Reducing the loader counter (when it reaches 0 the loading is done):
		global.subLoader = () => {
			setTimeout(() => this.setState({ loaderCount: Math.max(this.state.loaderCount - 1, 0) }), 0);
		}

		this.setGoogleTagManagerDataLayer = (isEnd) => {

			// @TODO - activate preview check:
			// if(global.isPreview) return;

			let utmSource = '';
			let utmMedium = '';

			if (global._queryDict) {

				utmSource = global._queryDict["utm_source"];
				utmMedium = global._queryDict["utm_medium"];
			}

			const pos = isEnd ? this.state.pos + 1 : this.state.pos;
			const step = this.state.steps[pos];
			const stepData = step[step.type];

			const isStart = pos === 0;

			const url = isEnd ?
				`/${props.sekerKey}/survey-end`
				:
				isStart ?
					`/${props.sekerKey}/survey-start`
					:
					`/${props.sekerKey}/question-${this.state.stepsCount}`;


			const dataLayer = {
				'event': 'virtualPageview',
				'virtualPageURL': url, // כאן צריכה לבוא הכתובת של העמוד 
				'virtualPageTitle': (stepData.question || stepData.title || stepData.description), // כאן צריך לבוא טייטל לכל עמוד
				'questionID': step.qKey, // כאן צריך לבוא המזהה היוניקי לכל שאלה
				'surveyID': props.sekerKey, // כאן צריך לבוא המזהה היוניקי לכל סקר
				'utmSource': utmSource, //
				'utmMedium': utmMedium,
				'CID': LS.get('_ga')
			}

			// console.log( JSON.stringify( dataLayer, null, 2 ) );

			TagManager.dataLayer({
				dataLayer
			})

			if (isStart) {
				TagManager.dataLayer({
					'event': 'GA_event',
					'eventCategory': 'Surveys',
					'eventAction': 'Survey_Started',
					'eventLabel': props.sekerKey
				})
			}

			if (isEnd) {
				TagManager.dataLayer({
					'event': 'GA_event',
					'eventCategory': 'Surveys',
					'eventAction': 'Survey_Ended',
					'eventLabel': props.sekerKey
				})
			}

			this.setState({ stepsCount: this.state.stepsCount + 1 })
		}

	}

	componentDidMount() {
		// const {hash} = window.location;

		// window.location = `#0`;
		global.maxStep = 0;
		global.ansData = {}

		global.ansData["group"] = global.group;
		window.addEventListener("resize", this.updateDimensions.bind(this));
		this.updateDimensions();

		global.startTimeStamp = Date.now();

		this.setState({ stepStartTimestamp: Date.now() });

		listenForSbsEvents(this);
	}

	//Navigate straight to the desired screen when arriving from the editor:
	previewNav() {
		const previewScreenID = this.props.userId.slice(13);

		if (previewScreenID === "12345") {
			this.Nav(0);
			return;
		}

		let nextPos;

		for (let i = 0; i < this.state.steps.length; i++) {
			if (this.state.steps[i]["_id"] === previewScreenID) {
				nextPos = i;
			}
		}

		if (nextPos === undefined) {
			console.log("[previewNav] error while looking for following screen");
			return;
		}

		this.Nav(nextPos);
	}

	updateDimensions() {
		const isHorizontal = global.isMobile && this.state.pos === 0 && (window.innerHeight < window.innerWidth);

		this.setState({
			winHeight: window.innerHeight,
			winWidth: window.innerWidth,
			isHorizontal: isHorizontal,
		})
	}

	Nav(nextPos) {

		const { sbsProps } = this.state.steps[nextPos]

		if (sbsProps) {
			const sbsPropsObj = JSON.parse(sbsProps);
			handleSbs(sbsPropsObj);

			if (sbsPropsObj.hotspots && sbsPropsObj.hotspots.length > 0) {

				this.setState({ allowNext: false })
			} else {

				this.setState({ allowNext: true })
			}

		} else {
			this.setState({ allowNext: true })
		}


		this.setCacheAnswer('curScreen', nextPos)
		//Update the visual effects in the background:
		if (global.browser !== "ie" && global.webGlSupported) {
			global.setBgStep((nextPos + 1) / this.state.steps.length);
		}
		try {
			global._curPos = `${this.props.sekerKey}/${nextPos}-${this.state.steps[nextPos].name}`
		} catch (e) {
			// pass
		}
		this.setState({ pos: nextPos, lastPos: this.state.pos, makeTransition: false },
			() => setTimeout(() => { //Adding a short delay before transitioning to the next screen so that the animation will play properly 
				this.setState({ makeTransition: true, stepStartTimestamp: Date.now() });
			}, 100));

	}

	render() {
		const {
			winHeight,
			winWidth,
			pos,
			steps,
			lastPos,
			makeTransition,
			isHorizontal,
			hideStepNumbers,
			hideSerialNumber,
			surveyNotFound,
			allowNext
		} = this.state;
		const H = 640;
		const W = 360;
		const scale = global.isMobile ? winWidth / W : 1;

		const desktopPadding = 12;
		let desktopRootScale = Math.min(1, desktopRootScale = winHeight / (H + desktopPadding * 2 + 64));

		if (surveyNotFound) return <NotFoundPage />

		if (isHorizontal) return <div style={{
			width: '100%',
			height: '100%',
			paddingTop: 96,
			display: 'flex',
			alignItems: 'center',
			textAlign: 'center',
			justifyContent: 'center',
		}}><h2>סובבו את המסך אנכית</h2><i className="material-icons">screen_rotation</i></div>;

		const mobileRootStyle = {
			position: "absolute",
			width: winWidth,
			height: winHeight,
			top: 0,
			left: 0,
			overflow: "hidden",
			backgroundColor: global.colorTheme.background,
			padding: 0,
		}

		const desktopRootStyle = {
			position: "absolute",
			width: W,
			height: H,
			top: (winHeight - (H + desktopPadding + 16)) / 2,
			left: (winWidth - (W + desktopPadding * 2)) / 2,
			overflow: "hidden",
			backgroundColor: global.colorTheme.background,
			padding: desktopPadding,
			boxShadow: "0 8px 32px 0px rgba(0,0,0,0.2)",
			borderRadius: 16,
			transform: `scale(${desktopRootScale})`
		}

		return <div id="seker_root" className="App"
			style={global.isMobile ? mobileRootStyle : desktopRootStyle}>
			{(global.browser !== "ie" && global.webGlSupported) && <BackgroundEffects imgUrl={this.state.bgImgUrl}
				canvasWidth={global.isMobile ? winWidth : W + desktopPadding * 2}
				canvasHeight={global.isMobile ? winHeight : H + desktopPadding * 2} />}

			<TopNav
				style={{
					position: "absolute",
					width: "100%",
					top: global.isMobile ? 0 : desktopPadding,
					zIndex: 10,
					opacity: this.state.loaderCount > 0 ? 0.1 : 1,
					pointerEvents: this.state.loaderCount > 0 ? "none" : "auto",
				}}
				hideStepNumbers={hideStepNumbers}
				hideSerialNumber={hideSerialNumber}
				currentPos={this.state.pos}
				steps={this.state.steps}
				userId={this.props.userId}
			/>

			<Loader H={H} W={global.isMobile ? winWidth : W + desktopPadding * 2} isLoading={this.state.loaderCount > 0} />
			<div style={{
				position: "absolute",
				zIndex: 2,
				bottom: global.isMobile ? 0 : desktopPadding,
				left: global.isMobile ? (winWidth - W) / 2 : desktopPadding,
				width: W,
				height: H,
				transformOrigin: "bottom center",
				transform: "scale(" + scale + ")",
				userSelect: "none",
				overflow: "visible",
			}}>

				{steps.map((_Cmp, i) => {

					if (i !== lastPos && i !== pos) return null;

					let isCurrent = false;
					let w = global.isMobile ? W : W + desktopPadding;
					let left;


					if (i === lastPos) {
						left = w;
					}

					if (i === pos) {
						isCurrent = true;
						if (makeTransition) {
							left = 0;
						} else {
							left = -w;
						}
					}

					const RealCmp = COMP_DICT[_Cmp.type]
					const cmpProps = _Cmp[_Cmp.type]
					const hide = this.state.loaderCount > 0;

					return <RealCmp
						key={i}
						{...cmpProps}
						isCurrent={isCurrent}
						qKey={_Cmp.qKey}
						followingScreen={_Cmp.followingScreen}
						/**
						 * allowNext is for special cases where continuation to the next screen is dependant on data outside of the component context.
						 */
						allowNext={allowNext}
						style={{
							position: "absolute",
							top: 0,
							left,
							width: W,
							bottom: 0,
							transition: "left 0.3s ease-out",
							display: hide ? 'none' : '',
							pointerEvents: this.state.loaderCount > 0 ? "none" : "auto",
						}}
					/>
				})}
			</div>
		</div>;
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/SekerApp.js